import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface InfoIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const InfoIconUnified = observer('InfoIconUnified', ({ className, onClick }: InfoIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            clipRule='evenodd'
            fill='none'
            fillRule='evenodd'
            height='32'
            onClick={onClick}
            strokeLinejoin='round'
            strokeMiterlimit='2'
            viewBox='0 0 32 32'
            width='32'
            xmlns='http://www.w3.org/2000/svg'
            data-test='info-icon'
        >
            <mask
                id='mask0_2058_27350'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='2'
                y='2'
                width='28'
                height='28'
            >
                <path
                    d='M16.9503 22.2837C17.2059 22.0281 17.3337 21.7114 17.3337 21.3337V16.0003C17.3337 15.6225 17.2059 15.3059 16.9503 15.0503C16.6948 14.7948 16.3781 14.667 16.0003 14.667C15.6225 14.667 15.3059 14.7948 15.0503 15.0503C14.7948 15.3059 14.667 15.6225 14.667 16.0003V21.3337C14.667 21.7114 14.7948 22.0281 15.0503 22.2837C15.3059 22.5392 15.6225 22.667 16.0003 22.667C16.3781 22.667 16.6948 22.5392 16.9503 22.2837ZM16.9503 11.617C17.2059 11.3614 17.3337 11.0448 17.3337 10.667C17.3337 10.2892 17.2059 9.97255 16.9503 9.71699C16.6948 9.46144 16.3781 9.33366 16.0003 9.33366C15.6225 9.33366 15.3059 9.46144 15.0503 9.71699C14.7948 9.97255 14.667 10.2892 14.667 10.667C14.667 11.0448 14.7948 11.3614 15.0503 11.617C15.3059 11.8725 15.6225 12.0003 16.0003 12.0003C16.3781 12.0003 16.6948 11.8725 16.9503 11.617ZM16.0003 29.3337C14.1559 29.3337 12.4225 28.9837 10.8003 28.2837C9.1781 27.5837 7.76699 26.6337 6.56699 25.4337C5.36699 24.2337 4.41699 22.8225 3.71699 21.2003C3.01699 19.5781 2.66699 17.8448 2.66699 16.0003C2.66699 14.1559 3.01699 12.4225 3.71699 10.8003C4.41699 9.1781 5.36699 7.76699 6.56699 6.56699C7.76699 5.36699 9.1781 4.41699 10.8003 3.71699C12.4225 3.01699 14.1559 2.66699 16.0003 2.66699C17.8448 2.66699 19.5781 3.01699 21.2003 3.71699C22.8225 4.41699 24.2337 5.36699 25.4337 6.56699C26.6337 7.76699 27.5837 9.1781 28.2837 10.8003C28.9837 12.4225 29.3337 14.1559 29.3337 16.0003C29.3337 17.8448 28.9837 19.5781 28.2837 21.2003C27.5837 22.8225 26.6337 24.2337 25.4337 25.4337C24.2337 26.6337 22.8225 27.5837 21.2003 28.2837C19.5781 28.9837 17.8448 29.3337 16.0003 29.3337Z'
                    fill='#1C1B1F'
                />
            </mask>
            <g mask='url(#mask0_2058_27350)'>
                <rect
                    width='32'
                    height='32'
                    fill='#0F1321'
                />
            </g>
        </SvgElement>
    );
});
